import { Box, Typography } from "@mui/material";
import { memo, useEffect } from "react";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import { hexToRgbA } from "../../../../../utils/utils";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "page.topmedSchedule.newSchedule.";

export const ConfirmedMessage = memo(() => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/schedule-teleconsultation/topmed-schedule");
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <Box
        sx={(t) => ({
          p: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: hexToRgbA(t.palette.success.main, 0.2),
          borderRadius: "100%",
        })}
      >
        <EventAvailableRoundedIcon
          color="success"
          sx={{ pt: 0.5, fontSize: 80 }}
        />
      </Box>
      <Typography variant="h5" fontWeight="bold">
        {t(TRANSLATION_PATH + "success")}
      </Typography>
    </Box>
  );
});
